module.exports = __webpack_public_path__ + "static/media/Stash-white.4ddbe674.svg";